import styled from "styled-components";
import { CartGroupContainer } from "@cart-ui/components/cart-group";
import { Image } from "@swiggy-private/core-ui";

export const Widget = styled(CartGroupContainer)`
    padding: ${({ theme }) => theme.spacing.medium};
`;

export const WidgetTopTitle = styled.div`
    margin-top: ${({ theme }) => theme.spacing.xxLarge};
`;

export const WidgetHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const WidgetHeaderText = styled.div`
    max-width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-right: ${({ theme }) => theme.spacing.xSmall};
`;

export const WidgetHeaderTextRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${({ theme }) => theme.colors[theme.colorMode].text_Highest_Emphasis};
`;

export const WidgetHeaderTextRowContent = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 400;
    font-family: Gilroy;
`;

export const WidgetHeaderTextRowGiftIcon = styled(Image)`
    width: 18px;
    height: 17px;
    margin: 0 6px;
`;

export const WidgetHeaderTextSubTitle = styled.div`
    color: ${({ theme }) => theme.colors[theme.colorMode].text_Med_Emphasis};
    margin-top: ${({ theme }) => theme.spacing.xxSmall};
`;

export const WidgetHeaderActionBtn = styled.div`
    white-space: pre;
`;
